import React from "react";

import useGetPortfolioPlanById from "@fartherfinance/frontend/api/Investment/hooks/useGetPortfolioPlanById";
import useGetPortfolioPlanFamilyPath from "@fartherfinance/frontend/api/Investment/hooks/useGetPortfolioPlanFamilyPath";
import { PortfolioPlanId } from "@fartherfinance/frontend/api/Types";

import { whitelistTaxStatus } from "@src/multiCustodian/components/Advisor/Investments/ModelMarketplaceV2/PortfolioPlanTab/PortfolioData";
import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";
import useApplicationMode from "@src/multiCustodian/hooks/useApplicationMode";
import useRequestAuth from "@src/multiCustodian/hooks/useRequestAuth";

import Charts from "./ChartsSection/Charts";
import Details, { CustomModelDetails } from "./DetailsSection/Details";
import useCreateFamilyPathFromData from "./useCreateFamilyPathFromData";

import styles from "./PortfolioDetailsSideBar.module.css";

interface Props {
  portfolioPlanId: PortfolioPlanId;
  customModelDetails?: CustomModelDetails;
}

const PickPortfolioDetailsSideBar: React.FC<Props> = ({
  portfolioPlanId,
  customModelDetails,
}) => {
  const { isAdvisorMode } = useApplicationMode();
  const clientAuth = useRequestAuth();
  const advisorAuth = useAdvisorRequestAuth();
  const auth = isAdvisorMode ? advisorAuth : clientAuth;

  const { isLoading, hasError, data } = useGetPortfolioPlanById(
    portfolioPlanId,
    {},
    auth
  );

  const portfolioFamilyPath = useGetPortfolioPlanFamilyPath(
    portfolioPlanId,
    auth
  );

  //Represents the Implementation Families structured in three levels: provider, series, and asset allocation.
  const familyPath = useCreateFamilyPathFromData(portfolioFamilyPath.data);

  return (
    <div className={styles.container}>
      {isLoading ? (
        <Details isLoading hasError={false} data={undefined} />
      ) : hasError ? (
        <Details
          hasError
          error={new Error("Unknown")}
          isLoading={false}
          data={undefined}
        />
      ) : (
        <Details
          data={{
            name: data.data.plan.name,
            tags: whitelistTaxStatus(data.data.plan.tags),
            customModelDetails: customModelDetails,
            provider: familyPath?.provider,
            modelSeries: familyPath?.series,
            assetAllocation: familyPath?.assetAllocation,
          }}
          isLoading={false}
          hasError={false}
        />
      )}

      <Charts portfolioPlanId={portfolioPlanId} />
    </div>
  );
};

export default PickPortfolioDetailsSideBar;
